export default {
  methods: {
    zipExportData() {
      this.fetchZipData();
    },
  },
}